import React from "react";
import Preloader from "../helper/Preloader";
 import Breadcrumb from "../components/Breadcrumb";
 import BottomFooter from "../components/BottomFooter";
 import ScrollToTop from "react-scroll-to-top";
 import HeaderOneCustomer from "../componentsAmazon/HeaderOneCustomer";
import CompareSectionAmazon from "../componentsAmazon/CompareSectionAmazon";
import FooterOne from "../components/FooterOne";
import HeaderOneVendorStore from "../componentsAmazon/HeaderOneVendorStore";
 

const ComparePageAmazon = () => {



  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOneVendorStore />
 

      {/* CartSection */}
      <CompareSectionAmazon />
 

      {/* FooterOne */}
      <FooterOne/>

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default ComparePageAmazon;
